module.exports = __webpack_public_path__ + "media/img/pages/companies/eandh-ecb9ed6735f59c592576de5d91b62265.png";